var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.092 11.58h-10.2V1.341c0-.375-.3-.675-.675-.675-.375 0-.638.3-.638.675v10.237H1.342c-.375 0-.675.3-.675.675 0 .375.3.638.675.638h10.237v10.2c0 .375.3.675.675.675.375 0 .675-.3.675-.675v-10.2h10.163c.375 0 .675-.3.675-.675 0-.375-.3-.638-.675-.638Z",
    fill: "#292723"
  })));
};
export default SvgPlus;